import { useAppUserAccess } from 'global/cnr/contexts/useHelpers/useAppUserAccess';
import { useContext, useEffect, useState } from 'react';
import { Segment } from 'semantic-ui-react';
import { ParentContext } from '../../../global/cnr/contexts/ParentContext';
import NoData from '../../../global/components/alerts/NoData';
import TicketingProvider, { TicketingContext } from '../cnr/contexts/TicketingContext';
import { ticketTypes } from './SingleTicket';
import Tickets from './Tickets';

const AppUserTicketing = (props) => {

  const { willCallTickets } = props ?? {}

  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { paps_state } = states ?? {}
  const appUserAccess = useAppUserAccess()
  const { appUserSessionKey, email, phoneNumber } = appUserAccess ?? {}
  const { viewKey } = paps_state ?? {}

  const _viewKey = viewKey ? viewKey : appUserSessionKey

  // ticketingContext
  const ticketingContext = useContext(TicketingContext)
  const { ticketing_state, ticketing_handlers } = ticketingContext ?? {}
  const { tickets, assignedTickets, currentAppUserTickets, appTicketing } = ticketing_state ?? {}
  const { ticketingCaption } = appTicketing ?? {}
  const _ticketCaption = ticketingCaption ? ticketingCaption : 'Tickets'

  const [showMessage, setShowMessage] = useState()

  useEffect(() => {
    if (!willCallTickets && assignedTickets) {
      ticketing_handlers.getCurrentAppUserTickets(_viewKey, email, phoneNumber, appUserAccess)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [assignedTickets]);

  useEffect(() => {
    if (willCallTickets) {
      ticketing_handlers.setCurrentAppUserTickets(willCallTickets)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [willCallTickets]);

  useEffect(() => {
    if (showMessage) {
      setTimeout(() => {
        setShowMessage()
      }, 5000)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showMessage]);

  const ticketGroups = () => <Tickets tickets={currentAppUserTickets} ticketType={willCallTickets ? ticketTypes.willCall : ticketTypes.single} />

  if (tickets && currentAppUserTickets) {
    return ticketGroups()
  } else {
    return <Segment style={{ height: '100%' }} basic inverted={willCallTickets ? true : false}>
      <NoData altCaption={_ticketCaption ? _ticketCaption : 'No Tickets'} />
    </Segment>
  }
}

const AppUserTicketingWithProvider = (props) => <TicketingProvider>
  <AppUserTicketing {...props} />
</TicketingProvider>

export default AppUserTicketingWithProvider